const cFooter = () => {
  const collapses = document.querySelectorAll(".footer .collapsable");

  const handleClick = ({ target }) => {
    const parent = target.closest(".collapsable");

    if (parent.classList.contains("active")) {
      parent.classList.remove("active");
    } else {
      collapses.forEach((collapse) => collapse.classList.remove("active"));
      parent.classList.add("active");
    }
  };

  collapses?.forEach((collapse) =>
    collapse.addEventListener("click", handleClick)
  );
};

export default cFooter;
